// extracted by mini-css-extract-plugin
export var icon = "_qy-0";